import { createContext } from 'react';

export const userContext = createContext({});

export default userContext;
